export default __webpack_public_path__ + "static/media/iPhone-X-PSD-Mockup-01-no-shadow.046d2500.png";